import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ITapesFormMeta {
    activeRejectTape: FormInputMeta;
    tapeTicket1Active: FormInputMeta;
    tapeTicket2Active: FormInputMeta;
    tapeTicket3Active: FormInputMeta;
    tapeTicket4Active: FormInputMeta;

}

const tapesFormMeta = {} as ITapesFormMeta;

tapesFormMeta.activeRejectTape = {
    name: "activeRejectTape",
    type: "checkbox",
    label: "Cassette de Rejet Actif",
    placeholder: "",
    validation: yup.boolean()
};

tapesFormMeta.tapeTicket1Active = {
    name: "tapeTicket1Active",
    type: "checkbox",
    label: "Cassette Billet 1 Actif",
    placeholder: "",
    validation: yup.boolean()
};

tapesFormMeta.tapeTicket2Active = {
    name: "tapeTicket2Active",
    type: "checkbox",
    label: "Cassette Billet 2 Actif",
    placeholder: "",
    validation: yup.boolean()
};

tapesFormMeta.tapeTicket3Active = {
    name: "tapeTicket3Active",
    type: "checkbox",
    label: "Cassette Billet 3 Actif",
    placeholder: "",
    validation: yup.boolean()
};

tapesFormMeta.tapeTicket4Active = {
    name: "tapeTicket4Active",
    type: "checkbox",
    label: "Cassette Billet 4 Actif",
    placeholder: "",
    validation: yup.boolean()
};


export default tapesFormMeta;